/* take from https://buyatoyota.atlassian.net/browse/BAT25-58 */
export default {
  default: [{
    elementType: 'geometry.fill',
    stylers: [{
      color: '#f1f1f2',
    }],
  },
  {
    featureType: 'administrative.land_parcel',
    elementType: 'labels',
    stylers: [{
      visibility: 'off',
    }],
  },
  {
    featureType: 'landscape.man_made',
    elementType: 'geometry.fill',
    stylers: [{
      color: '#f1f1f2',
    }],
  },
  {
    featureType: 'landscape.natural',
    elementType: 'geometry.fill',
    stylers: [{
      color: '#f1f1f2',
    }],
  },
  {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [{
      visibility: 'off',
    }],
  },
  {
    featureType: 'poi',
    elementType: 'labels.text',
    stylers: [{
      visibility: 'off',
    }],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry.fill',
    stylers: [{
      color: '#f1f1f2',
    }],
  },
  {
    featureType: 'road',
    elementType: 'geometry.fill',
    stylers: [{
      color: '#ffffff',
    }],
  },
  {
    featureType: 'road.arterial',
    elementType: 'labels',
    stylers: [{
      visibility: 'off',
    }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [{
      color: '#dadada',
    }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [{
      visibility: 'off',
    }],
  },
  {
    featureType: 'road.local',
    elementType: 'labels',
    stylers: [{
      visibility: 'off',
    }],
  },
  {
    featureType: 'transit',
    elementType: 'labels',
    stylers: [{
      visibility: 'off',
    }],
  },
  {
    featureType: 'water',
    elementType: 'geometry.fill',
    stylers: [{
      color: '#c2cee5',
    }],
  },
  ]
};
